import React from 'react';
import { Card, CardContent } from '../../../shared/components/ui/Card';

/**
 * CustomerMetrics - Displays customer metrics in a card grid
 * @param {Object} props
 * @param {number} props.totalCustomers - Total number of unique customers
 * @param {number} props.newCustomersThisMonth - New customers this month
 * @param {number} props.activeCustomers - Number of active customers
 * @param {number} props.inactiveCustomers - Number of inactive customers
 */
export function CustomerMetrics({ totalCustomers, newCustomersThisMonth, activeCustomers, inactiveCustomers }) {
    return (
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 mb-6">
            <Card>
                <CardContent className="p-3 sm:p-4">
                    <p className="text-xs sm:text-sm text-gray-500 line-clamp-2">Total Customer</p>
                    <p className="text-lg sm:text-2xl font-semibold text-primary mt-1">{totalCustomers}</p>
                </CardContent>
            </Card>
            <Card>
                <CardContent className="p-3 sm:p-4">
                    <p className="text-xs sm:text-sm text-gray-500 line-clamp-2">New customers this month</p>
                    <p className="text-lg sm:text-2xl font-semibold text-primary mt-1">{newCustomersThisMonth}</p>
                </CardContent>
            </Card>
            <Card>
                <CardContent className="p-3 sm:p-4">
                    <p className="text-xs sm:text-sm text-gray-500 line-clamp-2">Active Passes</p>
                    <p className="text-lg sm:text-2xl font-semibold text-primary mt-1">{activeCustomers}</p>
                </CardContent>
            </Card>
            <Card>
                <CardContent className="p-3 sm:p-4">
                    <p className="text-xs sm:text-sm text-gray-500 line-clamp-2">Inactive Passes</p>
                    <p className="text-lg sm:text-2xl font-semibold text-primary mt-1">{inactiveCustomers}</p>
                </CardContent>
            </Card>
        </div>
    );
}

